import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'red-purchase';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    redPurchaseDetails: '',
    redPurchaseId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setRedPurchaseDetails(state, data) {
        state.redPurchaseDetails = data
    },
    setRedPurchaseIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setRedPurchaseId(state, data) {
        state.redPurchaseId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setRedPurchaseRouterUrl(state, url) {
        state.routerUrl = url
    },
    setRedPurchaseIsView(state, flag) {
        state.isView = flag
    },
    setRedPurchaseDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/red-purchase/index.js